import { render, staticRenderFns } from "./VipLog.vue?vue&type=template&id=94951b3a&scoped=true&"
import script from "./VipLog.vue?vue&type=script&lang=js&"
export * from "./VipLog.vue?vue&type=script&lang=js&"
import style0 from "./VipLog.vue?vue&type=style&index=0&id=94951b3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94951b3a",
  null
  
)

export default component.exports